var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.86,
    height: 39.77,
    viewBox: "0 0 41.86 39.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 23.41 13.52 39.77 34.44 36.25 20.93 14.1 0 23.41",
    fill: "#abc4ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.34 0 41.86 16.36 34.44 36.25 20.93 19.89 15.2 9.15 28.34 0",
    fill: "#c4d6ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.93 19.89 28.34 0 7.41 3.52 0 23.41 20.93 19.89",
    fill: "#dde7ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance5);
export default __webpack_public_path__ + "static/media/entrance_5.595925e0e683bc1db0d1ecfb5d427e04.svg";
export { ForwardRef as ReactComponent };